import React from "react";

const fmtDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
};

export const LogEntryCard = ({ entry, style }) => (
  <div
    className="tag-card"
    data-testid={`log-entry-${entry.entry_number}`}
    style={{ marginBottom: 12, ...style }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
      <span style={{ color: "#777", fontSize: 13 }}>{fmtDate(entry.date)}</span>
      <span
        style={{
          color: "#FF6575",
          fontSize: 9,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          fontWeight: 700,
        }}
      >
        Entry #{String(entry.entry_number).padStart(2, "0")}
      </span>
    </div>
    <h3 style={{ color: "#fff", fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>{entry.headline}</h3>
    <p style={{ color: "#bbb", fontSize: 13, lineHeight: 1.7, margin: "0 0 12px", whiteSpace: "pre-wrap" }}>
      {entry.content}
    </p>
    {entry.tags && entry.tags.length > 0 && (
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {entry.tags.map((t) => (
          <span
            key={t}
            style={{
              background: "#0f0f0f",
              color: "#777",
              border: "1px solid #1a1a1a",
              borderRadius: 20,
              fontSize: 10,
              padding: "3px 10px",
            }}
          >
            {t}
          </span>
        ))}
      </div>
    )}
  </div>
);
